export const initialValuesIngCollaboratorProject = {
	selectProject: "",
	roleAttribue: "",
	roleHour: "",
	commentaireProjectCollaborator: "",
	dateStart: "",
	dateEnd: "",
}
